import {
  MessageReduxType,
  MessageStatus,
  MessageType,
} from "../constant/Types";
import { msg } from "../reducers/messagesRed";
import { getNormalizeObj } from "../constant/helper";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";

export const addNewMessage = (
  messageType = MessageType.client.text,
  messageData,
  moreData = {}
) => {
  let id = uuidv4();
  let payload = {
    ...msg,
    data: messageData ? messageData : msg.data,
    time: new Date().getTime(),
    type: messageType,
    status: MessageStatus.sending,
    clientMessageId: id,
    id,
    ...moreData,
  };

  return {
    type: MessageReduxType.add,
    data: payload,
  };
};

export const addBulkMessage = (messages = [], firstFetch = false) => {
  return {
    type: MessageReduxType.addBulk,
    data: messages,
    firstFetch,
  };
};

export const removeMessage = (messageId) => {
  return {
    type: MessageReduxType.deleted,
    data: messageId,
  };
};

export const cancelMessage = (state, msgData) => {
  if (!msgData || !state || (msgData && !msgData.id)) {
    message.error("خطایی در حذف پیام پیش امد");
    return false;
  }

  const { id, cancelToken } = msgData;

  let msg = haveMessage(state, id);
  if (msg === false) {
    return false;
  }

  if (cancelToken && msg.staus === MessageStatus.sending) {
    cancelToken();
  }

  return {
    type: MessageReduxType.cancel,
    data: { id },
  };
};

export const messageUpdateStatus = (
  id,
  clientMessageId,
  newStatus,
  cancelToken,
  file,
  fileId = null
) => {
  return {
    type: MessageReduxType.updateStatus,
    data: { id, clientMessageId, status: newStatus, cancelToken, file, fileId },
  };
};

export const voiceMessageDownloadStatus = (id, base64voice) => {
  return {
    type: MessageReduxType.updateVoice,
    data: { id, base64voice },
  };
};

function haveMessage(list, id) {
  let messagesNormal = getNormalizeObj(list);
  if (!messagesNormal || (messagesNormal && !messagesNormal[id])) {
    message.error("پیامی برای حذف یافت نشد!");
    return false;
  }
  return messagesNormal[id];
}
